import { FeatureFlag } from '@mews-commander/enums';
import { useTabs } from '@mews-commander/ui';
import { compactArray } from '@mews/fp';
import { useFeatureFlag } from '@mews/framework';

export const useLibraryTabs = () => {
    const isAttachmentLibraryEnabled = useFeatureFlag(FeatureFlag.contractingAttachmentLibraryEnabled);
    const isTemplateMappingEnabled = useFeatureFlag(FeatureFlag.contractingTemplateMappingEnabled);

    const tabs = useTabs(
        '/$currentEnterpriseId/Settings/ReservationContracts',
        compactArray([
            isTemplateMappingEnabled ? 'ExternalTemplates' : null,
            isAttachmentLibraryEnabled ? 'AttachmentLibrary' : null,
        ])
    );

    return tabs;
};
